import css from 'styled-jsx/css';

export default css`

.donutFake{
  width: 160px;
  margin: 0 auto;
}

.donutListFake{
  margin-top: 30px;
}

.ballUsageFake{
  width: 60px;
  margin: 0 auto;
}

.UsageListFake{
  margin-top: 30px;
}

.fakeName {
  position: relative;
  top: 4px;
  width: 55%;
  display: inline-block;
}
/* billDetailsFake */
.billDetailsFakeMovil{
  width:100%;
  max-width:767px;
}
.billDetailsFakePc{
  width:100%;
  margin:0 auto;
}

.histo{
  width: 608px;
  height: 180px;
  margin-top: 50px;

}
.histo svg{
  transform:translate(0,180px);
  overflow:visible;
}

.histo svg>rect{
  transform:scaleY(-1);

}

.containerFakeList .fakeList:nth-child(1) {
  margin-top: 30px;

}

.fakeList {
  width: auto;
  height: 55px;
  margin-bottom: 10px;
}

.smallContentFakeMovil{
  width:100%;
  height:235px;
  margin-bottom: 10px;
}
.smallContentFakeMovil .cardTCOL{
  height:235px;
}

.billFake .titleCard {
  color: var(--color-gp--blue);
}

.TvFuncionalitiesFake .pillCentered {
  margin:0 auto;
  width:100%;
}

.TVClientInfoFake{
  background-color:#fff;
}

.pillWithIconFake {
  font-size: 1.25rem;
  display:flex;
  font-size: 1.125rem;
  font-family: var(--regular-font);
  padding:10px 10px 10px 10px;
  align-items: center;
  border: 1px solid var(--color-gp--grey3);
  border-radius: 5px;
  min-height: 80px;
  background-color:white;
  position: relative;
  white-space: break-spaces;
  box-sizing: border-box;

  .ballUsageFake{
    width       : 40px;
    height      : 40px;
    margin      : auto 0;
    margin-right: 16px;
  }

  .textPillWithIcon{
    flex-grow:1;
    text-align:left;
    font-family:var(--regular-font);
    color: var(--color-gp--grey6);

    .labelWithTooltip{
      display: flex;
      align-items: center;

      .label {
        font-size: 1.125rem;
      }
      .labelTooltip{
        z-index: 1;
        margin-left: 0.5rem;
      }
    }
    .subLabel {
      color:  var(--color-gp--grey4);
      font-size: 1rem;
      margin-top: 0.18rem;
    }
    &--textInfoElement{
      margin-top: 0.125rem;
    }
  }
}

@media screen and (min-width: 768px) {
  .smallContentFakeMovil{
      width:100%;
  }
  .fakeList {
    width: 100%;
  }
}

`;